export default __webpack_public_path__ + "images/streker_gronn.png";